// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"32568":"fc2acf5697a30d7c","34462":"5b6fd6130d55f1ca","72845":"589d8a59a4be3154"}[chunkId] + ".css";
};